import Axios from 'axios'
import UIkit from 'uikit'
import router from '../../router'

const initialState = {
  inquiry_form: {
    processing: false,
    types: [],
    properties: [],
    check_in_date: new Date(),
    check_out_date: new Date(),
    no_of_guests: '1',
    name: '',
    email: '',
    contact_no: '',
    remarks: ''
  }
}

const InquiryModule = {
  namespaced: true,
  state: {
    ...initialState
  },
  mutations: {
    resetForm (state) {
      state.inquiry_form = {
        processing: false,
        types: [],
        properties: [],
        check_in_date: new Date(),
        check_out_date: new Date(),
        no_of_guests: '1',
        name: '',
        email: '',
        contact_no: '',
        remarks: ''
      }
    },
    setProcessing (state, status) {
      state.inquiry_form.processing = status
    }
  },
  actions: {
    async submitInquiry ({ commit, state, dispatch }) {
      try {
        commit('setProcessing', true)
        const payload = {
          ...state.inquiry_form,
          types: JSON.stringify(state.inquiry_form.types.length > 0 ? state.inquiry_form.types.map(item => item.name) : []),
          properties: JSON.stringify([state.inquiry_form.properties.name])
        }
        const res = await Axios.post('/inquiry', { ...payload })
        if (res) {
          dispatch('showNotification', { message: 'Inquiry submit successful', error: false })
          // reset-form
          commit('resetForm')
          // navigate to home
          router.push('/home')
        }
      } catch (e) {
        commit('setProcessing', false)
        dispatch('showNotification', { message: 'Error occurred, while submitting Inquiry', error: true })
        throw e
      }
    },
    showNotification ({ commit }, payload) {
      UIkit.notification({
        message: payload.message,
        status: payload.error ? 'danger' : 'success',
        pos: 'bottom-center',
        timeout: 5000
      })
    }
  },
  getters: {
    inquiryForm: (state) => {
      return state.inquiry_form
    }
  }
}

export default InquiryModule
